import { createMetaDef } from '@exodus/asset'

import tokensParams from './tokens.js'

const name = 'flare'
const displayName = 'Flare'
const ticker = 'FLR'
const primaryColor = '#E61E57'
const gradientColors = ['#E61E57', '#FF5485']
const gradientCoords = { x1: '0%', y1: '0%', x2: '100%', y2: '100%' }
const chainBadgeColors = gradientColors
const chainId = 14

const gasLimit = 21e3 // enough to send ETH to a normal address
const contractGasLimit = 1e6 // used when estimateGas fails
const airdropBip44 = 0x80_00_02_2a

const units = {
  wei: 0,
  Kwei: 3,
  Mwei: 6,
  Gwei: 9,
  szabo: 12,
  finney: 15,
  FLR: 18,
}

const assetType = 'ETHEREUM_LIKE'
const tokenAssetType = 'FLR_ERC20'
const blockExplorer = {
  addressUrl: (address) =>
    `https://flare-explorer.flare.network/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://flare-explorer.flare.network/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'FLR is the native token used for payments, transaction fees, governance, and staking on the Flare Network. Flare Network is an EVM-based layer-1 blockchain that helps app developers create bridges between networks.',
  website: 'https://flare.network/',
  twitter: 'https://twitter.com/FlareNetworks',
  reddit: 'https://www.reddit.com/r/FlareNetworks/',
  telegram: 'https://t.me/FlareNetwork',
}

const assetParams = {
  airdropBip44,
  assetType,
  blockExplorer,
  chainBadgeColors,
  chainId,
  contractGasLimit,
  displayName,
  gasLimit,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  ticker,
  tokenAssetType,
  units,
}

const tokenOverrides = (token) => ({
  ...token,
  blockExplorer: {
    ...token.blockExplorer,
    addressUrl: (address) =>
      `https://arbiscan.io/token/${encodeURIComponent(token.addresses.current)}?a=${encodeURIComponent(address)}`,
  },
  assetId: token.addresses.current.toLowerCase(),
  contract: token.addresses,
  gasLimit: 120e3,
})

export const { asset, tokens, assetsList } = createMetaDef({
  assetParams,
  tokensParams,
  tokenOverrides,
})

export default assetsList
